import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from 'src/redesign/features/AttendeesSidebar/store/constants';
import { AttendeeSidebarState } from 'src/redesign/features/AttendeesSidebar/types';
import {
  getAttendeeDataById,
  updateAttendeeData,
} from 'src/redesign/features/AttendeesSidebar/store/actions';

const initialState: AttendeeSidebarState = {
  view: null,
  currentAttendee: null,
  show: false,
  attendeeData: null,
  error: null,
  loading: false,
  updateError: null,
  updateLoading: false,
  activeTab: 0,
};

export const attendeeSidebarSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    attendeesSidebarChangeView: (state, action) => {
      state.view = action.payload;
      state.show = Boolean(action.payload);
    },
    attendeesSidebarChangeAttendee: (state, action) => {
      state.currentAttendee = action.payload;
    },
    attendeesSidebarSetActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAttendeeDataById.fulfilled, (state, action) => {
      state.attendeeData = action.payload.data;
      state.currentAttendee = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAttendeeDataById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAttendeeDataById.rejected, (state, action) => {
      state.error = action.error.message;
    });
    builder.addCase(updateAttendeeData.fulfilled, (state, action) => {
      state.updateLoading = false;
      state.updateError = null;
      // Update the attendeeData with the customer data from the action payload
      if (state.attendeeData && action.meta.arg.data.customer) {
        const { customer } = action.meta.arg.data;
        state.attendeeData = {
          ...state.attendeeData,
          first_name: customer.first_name || state.attendeeData.first_name,
          last_name: customer.last_name || state.attendeeData.last_name,
          email: customer.email || state.attendeeData.email,
        };
      }
      // Also update currentAttendee if it exists
      if (state.currentAttendee && action.meta.arg.data.customer) {
        const { customer } = action.meta.arg.data;
        state.currentAttendee = {
          ...state.currentAttendee,
          first_name: customer.first_name || state.currentAttendee.first_name,
          last_name: customer.last_name || state.currentAttendee.last_name,
          email: customer.email || state.currentAttendee.email,
        };
      }
    });
    builder.addCase(updateAttendeeData.rejected, (state, action) => {
      state.updateLoading = false;
      state.updateError = action.error.message;
    });
    builder.addCase(updateAttendeeData.pending, (state) => {
      state.updateLoading = true;
      state.updateError = null;
    });
  },
});

export const attendeesSidebarChangeView = attendeeSidebarSlice.actions.attendeesSidebarChangeView;

export const attendeesSidebarChangeAttendee =
  attendeeSidebarSlice.actions.attendeesSidebarChangeAttendee;

export const attendeesSidebarSetActiveTab = attendeeSidebarSlice.actions.attendeesSidebarSetActiveTab;
